import React from "react";
import { Link } from "react-router-dom";
import { setDashboardChart, removeDashboardChart, deleteChart } from "../../services/ChartService";
import OutlierTable from "./OutlierTable";
import ParticipantOutlierDetection from "../2AFC/component/participantOutlierDetection";

class PartOutlierPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            jwtToken: props.jwtToken,
            outlierIndex: props.outlierIndex,
            outlierData: props.outlierData,
        };
        this.handleDelete         = this.handleDelete.bind(this);
        this.addToDashboard       = this.addToDashboard.bind(this);
        this.removeFromDashboard  = this.removeFromDashboard.bind(this);
        this.updateParent         = this.updateParent.bind(this);
    }

    updateParent() { this.props.handleUpdate(); }

    handleDelete() {
        deleteChart(this.state.jwtToken, this.state.outlierData.id).then(response => {
            if (response.ok) {
                this.props.showAlert({ type: "success", message: "Outlier table removed successfully." });
                this.updateParent();
            } else {
                this.props.showAlert({ type: "error", message: "Outlier table could not be removed." });
            }
        });
    }

    addToDashboard() {
        setDashboardChart(this.state.jwtToken, this.state.outlierData.id).then(response => {
            if (response.ok) {
                this.props.showAlert({ type: "success", message: "Outlier table added to dashboard." });
                this.updateParent();
            } else {
                this.props.showAlert({ type: "error", message: "Outlier table could not be added to dashboard." });
            }
        });
    }

    removeFromDashboard() {
        removeDashboardChart(this.state.jwtToken, this.state.outlierData.id).then(response => {
            if (response.ok) {
                this.props.showAlert({ type: "success", message: "Outlier table removed from dashboard." });
                this.updateParent();
            } else {
                this.props.showAlert({ type: "error", message: "Outlier table could not be removed from dashboard." });
            }
        });
    }

    render() {
        const { outlierData } = this.state;
        const pinned = outlierData.pinnedToDashboard;
        const hasData = outlierData.outlierData && Object.keys(outlierData.outlierData).length > 0;

        return (
            <div style={{ width: "100%", marginTop: "20px" }}>
                <table style={{ border: "1px lightgray solid", width: "100%" }}>
                    <thead>
                    <tr style={{ height: "40px", background: "lightgray" }}>
                        <th style={{ paddingLeft: "20px" }}>
                            <span>{outlierData.name}</span>
                            <Link to={"#"}>
                                <span title="Delete table"
                                      className="glyphicon glyphicon-trash"
                                      style={{ float: "right", marginRight: "15px", marginTop: "2px" }}
                                      onClick={this.handleDelete}/>
                            </Link>
                            <Link to={"#"}>
                                {pinned ?
                                    <span title="Remove from dashboard"
                                          className="glyphicon glyphicon-bookmark"
                                          style={{ float: "right", marginRight: "15px", marginTop: "2px", color: "darkred" }}
                                          onClick={this.removeFromDashboard} /> :
                                    <span title="Show in dashboard"
                                          className="glyphicon glyphicon-bookmark"
                                          style={{ float: "right", marginRight: "15px", marginTop: "2px" }}
                                          onClick={this.addToDashboard} />
                                }
                            </Link>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td style={{ padding: "20px", maxWidth: 0 }}>
                            {!hasData ? (
                                <div style={{
                                    padding: "14px 18px",
                                    background: "#fffbeb",
                                    border: "1px solid #fde68a",
                                    borderRadius: "6px",
                                    textAlign: "center",
                                    fontSize: "13px",
                                    color: "#92400e"
                                }}>
                                    <strong>No data available.</strong>
                                </div>
                            ) : (
                                <>
                                    {this.props.twoAfcs && this.props.twoAfcs.length > 0 && (
                                        <div style={{ marginBottom: "20px" }}>
                                            <div style={{ display: "flex", gap: "16px", alignItems: "flex-start", flexWrap: "wrap" }}>
                                                <div style={{ flex: "1 1 calc(50% - 8px)", minWidth: "320px", overflowX: "auto" }}>
                                                    <ParticipantOutlierDetection
                                                        data={this.props.twoAfcs[0]}
                                                        modelType="BT"
                                                        jwtToken={this.state.jwtToken}
                                                        handleUpdate={this.updateParent}
                                                    />
                                                </div>
                                                <div style={{ flex: "1 1 calc(50% - 8px)", minWidth: "320px", overflowX: "auto" }}>
                                                    <ParticipantOutlierDetection
                                                        data={this.props.twoAfcs[0]}
                                                        modelType="TM"
                                                        jwtToken={this.state.jwtToken}
                                                        handleUpdate={this.updateParent}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    <div style={{ borderRadius: "8px", boxShadow: "0 2px 6px rgba(0,0,0,0.08)" }}>
                                        <div style={{ background: "#374151", padding: "8px 14px", display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px 8px 0 0" }}>
                                            <h4 style={{ margin: 0, color: "white", fontSize: "13px", fontWeight: "600" }}>Participant Variable Data</h4>
                                            <span style={{ color: "rgba(255,255,255,0.65)", fontSize: "10px" }}>variable: {outlierData.variable || outlierData.name}</span>
                                        </div>
                                        <div style={{ borderLeft: "1px solid #cbd5e1", borderRight: "1px solid #cbd5e1", padding: "4px 14px", background: "#f9fafb", borderBottom: "1px solid #e5e7eb", fontSize: "11px", color: "#6b7280" }}>
                                            Each row is one participant with their recorded values for the selected variable.
                                        </div>
                                        <div style={{ borderLeft: "1px solid #cbd5e1", borderRight: "1px solid #cbd5e1", background: "white" }}>
                                            <OutlierTable
                                                outlierData={outlierData.outlierData}
                                                jwtToken={this.state.jwtToken}
                                                handleUpdate={this.props.handleUpdate}
                                            />
                                        </div>
                                        <div style={{ borderLeft: "1px solid #cbd5e1", borderRight: "1px solid #cbd5e1", borderBottom: "1px solid #cbd5e1", borderRadius: "0 0 8px 8px", borderTop: "1px solid #e5e7eb", padding: "5px 14px 6px", background: "#f9fafb", fontSize: "11px", color: "#6b7280", display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
                                            <span>Scroll horizontally to view all</span>
                                            <span>|</span>
                                            <span>× = no value recorded for this participant</span>
                                            <span>|</span>
                                            <span>Mini bars show value relative to column average</span>
                                        </div>
                                    </div>
                                </>
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

export default PartOutlierPanel;
